import React, { useEffect } from 'react';
import '../../assets/scss/page/diagnostic-page-style.scss';
import FirstScreenPage from '../FirstScreenPage';
import LoginPage from '../LoginPage';
import { useRecoilValue } from 'recoil';
import { informationAtom } from '../../store/InformationStore';
import FreeInternetRightsPage from '../FreeInternetRightsPage';
import InternetPackagesPage from '../InternetPackagesPage';
import MilesAndSmilesRegisterPage from '../MilesAndSmilesRegisterPage';
import FeedbackPage from '../FeedbackPage';
import RemainingUsagePage from '../RemainingUsagePage';
import PurchasePackagePage from '../PurchasePackagePage';
import PaymentPage from '../PaymentPage';
import FrequentlyAskedQuestionsPage from '../FrequentlyAskedQuestionsPage';
import LoginOtherPage from '../LoginOtherPage';
import ForgotPasscodePage from '../ForgotPasscodePage';
import { startSimulation } from '../../api/ifec-verify-services/IfecVerifyService';

const SimulationPage = (props) => {
    const { t, i18n, handleInformation } = props.props;
    const information = useRecoilValue(informationAtom);

    const [simulationNumber, setSimulationNumber] = React.useState('');

    useEffect(() => {
        handleInformation('simulation');
        setSimulationNumber(information.clickAddress);
        topScroll();
    }, [information.clickAddress]);

    useEffect(() => {
        startSimulation();
        if (!/tr/.test(i18n.language?.toLowerCase())) {
            i18n.changeLanguage('tr');
        }
        setTimeout(() => {
            setSimulationNumber('/login');
            topScroll();
        }, 1000);
    }, []);

    const topScroll = () => {
        window.document.documentElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    return (
        <div>

            {simulationNumber === '' &&
                <FirstScreenPage initListener={props.initListener} props={props.props} />
            }

            {simulationNumber === '/login' &&
                <LoginPage props={props.props} />
            }

            {simulationNumber === '/free-internet-rights' &&
                <FreeInternetRightsPage props={props.props} />
            }

            {simulationNumber === '/internet-packages' &&
                <InternetPackagesPage props={props.props} />
            }

            {simulationNumber === '/miles-and-smiles-register' &&
                <MilesAndSmilesRegisterPage props={props.props} />
            }

            {simulationNumber === '/feedback' &&
                <FeedbackPage props={props.props} />
            }

            {simulationNumber === '/remaining-usage' &&
                <RemainingUsagePage props={props.props} />
            }

            {simulationNumber === '/purchase-package' &&
                <PurchasePackagePage props={props.props} />
            }

            {simulationNumber === '/payment' &&
                <PaymentPage props={props.props} />
            }

            {simulationNumber === '/frequently-asked-questions' &&
                <FrequentlyAskedQuestionsPage props={props.props} />
            }

            {simulationNumber === '/login-other' &&
                <LoginOtherPage props={props.props} />
            }

            {simulationNumber === '/forgot-password' &&
                <ForgotPasscodePage props={props.props} />
            }

        </div>
    );
};

export default SimulationPage;
